import styled from "@emotion/styled";

export const ComplaintDescription = styled("div")`
  margin-left: 20px;
  .title {
    font-weight: 700;
    margin-bottom: 5px;
  }

  .description {
    text-indent: 30px;
    margin-bottom: 5px;
  }
`;
